import {Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';
import {Hal} from '../models/HAL/hal.model';

// A HAL resource that can drive the right-side panels (case or document). Only the
// link relations present on the resource decide which panels appear.
export interface PanelHal extends Hal {
  identification: string;
}

@Injectable({
  providedIn: 'root'
})
export class CommentContextService {
  private readonly _panelHal = signal<PanelHal | null>(null);
  public panelHal = this._panelHal.asReadonly();

  private readonly _caseRefreshRequested = new Subject<void>();
  public readonly caseRefreshRequested = this._caseRefreshRequested.asObservable();

  setPanelHal(panelHal: PanelHal | null) {
    this._panelHal.set(panelHal);
  }

  requestCaseRefresh() {
    this._caseRefreshRequested.next();
  }
}
